<template>
  <div class="environment-widget">
    <div class="widget-content" v-if="environment === 'development'">
        Development
    </div>
  </div>
</template>

<script>
export default {
  name: "Environment",
  data() {
    return {
      environment: process.env.NODE_ENV
    }
  }
}
</script>

<style scoped lang="scss">
.environment-widget .widget-content {
  position: fixed;
  bottom: 0.5rem;
  left: 0.5rem;
  padding: 0.5rem 1rem;
  background: $danger;
  color: $white;
  z-index: $z-index-environment-widget;
  border: 2px solid black;
  border-radius: 5px;
  opacity: 0.96;
  word-break: break-all;
}
</style>